import $ from 'jquery';
import whatInput from 'what-input';
import A11yUtils from '@core/base/scripts/utils/a11y-utils';
import Utils from '@core/base/scripts/utils/utils';

export default class AlertPopup {

  constructor() {
    this.$popup = null;
    this.$btnClose = null;
    this.$focusables = null;
  }

  init(container) {
    this.$popup = $('.alert-popup', container);
    this.timeStamp=String(this.$popup.data('timestamp'));
    this.$btnClose = $('.alert-popup__close', this.$popup);
    this.$focusables = this.$popup.find(A11yUtils.FOCUSABLES_VISIBLE);
    //
    if(Utils.getCookie('alertUpdated')){
      if(Utils.getCookie('alertUpdated') !== this.timeStamp){
        this.displayPopup();
      }
    }else{
      this.displayPopup();
    }


    //
    this.$focusables.on('keydown', evt => {
      const key = evt.which;
      const target = evt.target;

      if (key === A11yUtils.keyboard.esc) {
        this.destroy();
      }

      if (key === A11yUtils.keyboard.tab) {
        this.tab(evt, target);
      }
    });
    //
    this.$btnClose.on('click', e => {
      e.preventDefault();
      this.destroy();
    });
  }

  displayPopup(){
      this.$popup.addClass('alert-popup--show');
      if (whatInput.ask() === 'keyboard') {
        this.$btnClose.focus();
      }
  }

  tab(evt, target) {
    if (evt.shiftKey) {
      if (this.$focusables && target === this.$focusables[0]) {
        evt.preventDefault();
        this.$focusables[this.$focusables.length - 1].focus();
      }
    } else if (this.$focusables && target === this.$focusables[this.$focusables.length - 1]) {
      evt.preventDefault();
      this.$focusables.first().focus();
    }
  }

  destroy() {
    Utils.setCookie('alertUpdated',this.timeStamp);
    this.$btnClose = null;
    this.$popup.remove();
    if (whatInput.ask() === 'keyboard') {
      A11yUtils.getFocusablesOnpage().first().focus();
    }
  }
}
